"use client";

import { cn } from "@/lib/utils";
// import { Loader2 } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
// import { useEffect, useState } from "react";
// import { motion } from "framer-motion";

export const FooterBlog = () => {
  const router = useRouter();
  const pathname = usePathname();

  // const [name, setName] = useState("");
  // const [email, setEmail] = useState("");
  // const [acceptTerms, setAcceptTerms] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [success, setSuccess] = useState(false);
  // const [emailError, setEmailError] = useState("");

  const handleNavigation = (href: string) => async (e: any) => {
    e.preventDefault();

    if (href.startsWith("/#")) {
      const targetPath = "/";
      const hash = href.split("#")[1];

      if (pathname === targetPath) {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        await router.push(targetPath + href);
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 100);
      }
    } else {
      router.push(href);
    }
  };

  const isValidEmail = (value: string) => {
    // Basic email validation regex
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(value);
  };

  // const handleEmailChange = (value: string) => {
  //   setEmail(value);

  //   // Validate on change
  //   if (value && !isValidEmail(value)) {
  //     setEmailError("Por favor insira um e-mail válido");
  //   } else {
  //     setEmailError("");
  //   }
  // };

  // const handleSendEmail = async () => {
  //   if (!isValidEmail(email)) {
  //     setEmailError("Por favor insira um e-mail válido");
  //     return;
  //   }

  //   setLoading(true);
  //   setEmailError("");

  //   const payload = { name, email };

  //   try {
  //     const response = await fetch("/api/newsletter", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     if (!response.ok) {
  //       console.error("Failed to send data");
  //       return;
  //     } else {
  //       setLoading(false);
  //       setEmail("");
  //       setName("");
  //       setAcceptTerms(false);
  //       setSuccess(true);
  //     }
  //   } catch (error) {
  //     console.error("Error sending data to external API:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const isDisabled = loading || !name || !email || !acceptTerms || !!emailError;

  // useEffect(() => {
  //   const scrollToHash = () => {
  //     if (typeof window !== "undefined") {
  //       const hash = window.location.hash;
  //       if (hash) {
  //         const id = hash.replace("#", "");
  //         const element = document.getElementById(id);
  //         if (element) {
  //           element.scrollIntoView({ behavior: "smooth" });
  //         }
  //       }
  //     }
  //   };

  //   scrollToHash();
  // }, []);

  return (
    <footer className="flex  flex-col  w-full md:mx-0 md:items-center md:justify-center">
      {/* {success && (
        <Toast
          message="E-mail cadastrado com sucesso!"
          onClose={() => setSuccess(false)}
        />
      )} */}
      {/* <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 30 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 1.6, delay: 5, ease: "easeOut" }}
        whileHover={{
          scale: 1.03,
          transition: { duration: 1.3, ease: "easeInOut" },
        }}
        whileTap={{ scale: 1.97 }}
        className="flex flex-col justify-center items-center w-full max-w-[1200px] mx-auto px-6 md:px-0 mt-10"
      >
        <div className="p-10 bg-brand-darker gap-3 rounded-[32px] flex flex-col md:flex-row justify-between w-full">
          <div className="flex flex-col gap-5 md:w-[480px]">
            <h3 className="text-2xl md:text-4xl text-white">
              <span className="text-2xl md:text-4xl text-[#f7df37]">
                Receba novidades
              </span>{" "}
              e conteúdos exclusivos direto no seu e-mail!
            </h3>
            <p className="text-sm md:text-[20px] text-[#ccc]">
              Assine e receba novidades, dicas e conteúdos exclusivos no seu
              email
            </p>
          </div>

          <div className="flex flex-col md:w-[520px] gap-6">
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Seu nome"
              className="pl-10 text-sm min-w-full h-12 sm:min-w-96 px-4 rounded-2xl border focus:ring-0 focus:outline-none outline-none text-gray-900 placeholder-neutral-400"
            />
            <input
              type="text"
              value={email}
              onChange={(e) => handleEmailChange(e.target.value)}
              placeholder="Seu e-mail"
              className="pl-10 text-sm min-w-full h-12 sm:min-w-96 px-4 rounded-2xl border focus:ring-0 focus:outline-none outline-none text-gray-900 placeholder-neutral-400"
            />

            <div className="flex">
              <input
                type="checkbox"
                name="terms"
                id="terms"
                checked={acceptTerms}
                onChange={() => setAcceptTerms(!acceptTerms)}
              />
              <label htmlFor="terms" className="text-[#ccc] text-sm  pl-2">
                Li e concordo com os{" "}
                <span className="text-[#f7df37] text-sm underline cursor-pointer">
                  Termos de Uso
                </span>{" "}
                e a{" "}
                <span className="text-[#f7df37] text-sm underline cursor-pointer">
                  Política de Privacidade
                </span>
              </label>
            </div>

            <button
              disabled={isDisabled}
              onClick={handleSendEmail}
              className={cn(
                "w-full h-12 bg-[#f7df37] flex items-center justify-center text-black rounded-2xl",
                isDisabled && "cursor-not-allowed opacity-60"
              )}
            >
              {loading ? (
                <Loader2 className="w-6 h-6 animate-spin" />
              ) : (
                "Enviar e me cadastrar"
              )}
            </button>
          </div>
        </div>
      </motion.div> */}
      <div
        className={cn(
          "flex w-full items-center justify-center px-4 py-8 md:py-40 md:max-w-[1200px]"
        )}
      >
        <div className="flex w-full max-w-[1216px] flex-col justify-between space-y-10 md:flex-row lg:space-y-0">
          <div>
            <a href="https://clickcannabis.com">
              <Image
                src="/logo.webp"
                alt="Logotipo"
                priority={true}
                width={140}
                height={20}
                className="h-[20px] w-[140px]"
              />
            </a>
            <p className="pt-8">Clickcannabis S.A.</p>
            <p className="pt-2">CNPJ 58.090.406/0001-92</p>
            <p className="pt-16">© 2025 Todos os direitos reservados</p>
          </div>
          <div>
            <div className="flex flex-row gap-8">
              <div className="flex flex-col gap-2">
                <p className="text-lg font-bold">Páginas</p>
                <ul className="flex flex-col gap-4">
                  <li>
                    <Link
                      href="/#como-funciona"
                      onClick={handleNavigation("/#como-funciona")}
                      className="text-gray-700 hover:text-brand-dark"
                    >
                      Como funciona
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/galeria"
                      onClick={handleNavigation("/galeria")}
                      className="text-gray-700 hover:text-brand-dark"
                    >
                      Galeria
                    </Link>
                  </li>

                  <li>
                    <Link
                      href="/sobre-nos"
                      onClick={handleNavigation("/sobre-nos")}
                      className="text-gray-700 hover:text-brand-dark"
                    >
                      Sobre nós
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/duvidas-frequentes"
                      onClick={handleNavigation("/duvidas-frequentes")}
                      className="text-gray-700 hover:text-brand-dark"
                    >
                      FAQ
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-lg font-bold">Outros</p>
                <Link
                  href="/termos-de-uso"
                  target="_blank"
                  className="cursor-pointer underline"
                >
                  Termos de uso
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

// const Toast = ({
//   message,
//   onClose,
// }: {
//   message: string;
//   onClose: () => void;
// }) => {
//   return (
//     <div
//       className="fixed bottom-4 right-4 flex items-center justify-between bg-[#f7df37] text-black rounded-lg shadow-lg p-4 min-w-[250px] max-w-[300px] z-50
//         transition-all duration-300
//       "
//       role="alert"
//     >
//       <span>{message}</span>
//       <button onClick={onClose} className="ml-4 text-black font-bold">
//         X
//       </button>
//     </div>
//   );
// };
